import { useNavigate } from "react-router-dom";
import "./Home.css";
import { useRef, useState } from "react";
import axios from "axios";

export const Home = () => {
  const numberRef = useRef();
  const otpRef = useRef();
  const navigate = useNavigate();

  const [showOTP, setShowOTP] = useState(false);
  const [enteredNumber, setEnteredNumber] = useState("");
  const [loading, setLoading] = useState(false);

  // -------------------------------
  // SEND OTP
  // -------------------------------
  const handleAccess = async () => {
    try {
      setLoading(true);

      const number = numberRef.current.value.trim();

      if (!number) return alert("Please enter your mobile number");
      if (number.length !== 10) return alert("Enter valid 10 digit number");

      // Save mobile number before OTP popup
      sessionStorage.setItem("mobileNumber", number);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/master`,
        { mobile_no: sessionStorage.getItem("mobileNumber") }
      );

      if (response.data.status) {
        setEnteredNumber(number);
        setShowOTP(true);
        alert("OTP sent successfully!");
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert("Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

  // -------------------------------
  // VERIFY OTP  (FIXED)
  // -------------------------------
  const handleVerifyOTP = async () => {
    try {
      setLoading(true);

      const otp = otpRef.current.value.trim();
      if (otp.length !== 4) return alert("Please enter a valid 4-digit OTP");

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/verify-otp`,
        { number: enteredNumber, otp }
      );

      if (res.data.status) {
        // ❌ Removed: sessionStorage.clear();  (this was deleting mobileNumber)

        // ✔ Save only token
        sessionStorage.setItem("token", res.data.token);

        alert("OTP Verified Successfully!");
        navigate("/BoothSelection");
      } else {
        alert("Invalid OTP, try again!");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      alert("OTP verification failed! Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="home-wrapper">
      <div className="access-container">
        <label>Enter Mobile Number:</label>
        <input
          type="tel"
          placeholder="Enter your 10-digit Mobile Number"
          ref={numberRef}
          maxLength="10"
        />

        <button
          className="access-btn"
          onClick={handleAccess}
          disabled={loading}
        >
          {loading ? "Processing..." : "Login"}
        </button>
      </div>

      {/* OTP Popup */}
      {showOTP && (
        <div className="otp-popup">
          <div className="otp-box">
            <h3>Enter the 4-digit OTP</h3>
            <input
              type="number"
              maxLength="4"
              ref={otpRef}
              placeholder="Enter OTP"
              className="otp-input"
            />
            <div className="otp-actions">
              <button
                onClick={handleVerifyOTP}
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
              <button
                onClick={() => setShowOTP(false)}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};